<div class="bg">
  <div #bg>
    <img [src]="image$ | async" [style.transform]="(translate$ | async) " />

  </div>
</div>
<div #container class="sceneContainer">


  <div #viewer class="viewer">
    <img #image [src]="image$ | async" [style.transform]="translate$ | async" />

    <div #overlays (click)="overlayClicked($event)" class="overlays"></div>


  </div>
  <div class="editWallDecorPiece" [ngClass]="{hide:hideElementEditIcons$ | async}">
    <lib-button (click)="openPhotoEditor()" icon-only>
      <mat-icon>edit</mat-icon>
    </lib-button>
  </div>
  <div #controls class="controls">
    @if ((currentIndex$ | async)!=='front') {
      <lib-button
        class="back"
        (click)="currentIndex$.next('front')"
        icon-only>
        <mat-icon>arrow_back</mat-icon>
      </lib-button>
    }
    <div [style.background]="
        color.value
      " class="container"
      id="wallDecorWallColorPicker"
      matTooltip="Dopasuj kolor ściany"
      (click)="showColorPicker$.next(!this.showColorPicker$.value)">


    </div>
    <lib-button icon-only class="rulerToggle" (click)="toggleRulers = !toggleRulers"
      id="RulersToggle"

      matTooltip="Pokaż wymiary">
      <mat-icon svgIcon="measure"></mat-icon>
    </lib-button>
    @if (showColorPicker$ | async) {
      <div class="zalamo-color-picker"
        (animate.enter)="animateColorPicker($event, true)" (animate.leave)="animateColorPicker($event, false)"


        >
        <p>Nasze kolory:</p>
        <div class="colors">
          @for (defaultColor of colors; track defaultColor) {
            <div [ngStyle]="{'background-color':defaultColor}"
              [ngClass]="{active:defaultColor===color.value}"
            (click)="color.patchValue( defaultColor)"></div>
          }
        </div>
        <div class="mineColor">Twój własny kolor:
        <div class="handPicker" [style.background]="
        color.value
      ">
            <input
              #me
            (colorPickerChange)="
        color.patchValue( $event)
      "
              [colorPicker]="color.value"
              [cpAlphaChannel]="'disabled'"
              [cpDisableInput]="true"
              />
            </div>
          </div>
        </div>
      }
      @if (preloaderVisible$ | async) {
        <div class="preloader">
          <div class="loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p>Komponujemy Twoją ścianę</p>
        </div>
      }
    </div>
  </div>
